import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'react-day-picker/lib/style.css';
import { Spinner } from 'react-activity';
import 'react-datepicker/dist/react-datepicker.css';
import { saveSoap, getPatientVisitEncounter } from '../../../action/VideoCallAction';
import store from '../../../../sessionStorage';
import { RESPONSE_CONSTANT } from '../../../../utils/ResponseConstant';
import NotesCompleteConfirmation from '../../common/NotesCompleteConfirmation';
import { showNotification } from '../../../action/NotificationAction';
import LanguageContext, { LanguageProvider } from '../../../../utils/common/LanguageContext';
import AppConfig from '../../../../utils/common/DomainConfiguration';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class ActiveVisitSoap extends Component {
    static propTypes = {
        onSave: PropTypes.func,
        subjective: PropTypes.string,
        objective: PropTypes.string,
        assessment: PropTypes.string,
        plan: PropTypes.string,
        visitEncounter: PropTypes.object,
        visitId: PropTypes.string,
        userId: PropTypes.string,
        patientUserId: PropTypes.string,
        onUpdateSoap: PropTypes.func,
        saveSoap: PropTypes.func,
        videoCallDetails: PropTypes.object,
        getPatientVisitEncounter: PropTypes.func,
    };
    constructor(props) {
        super(props);
        this.state = {
            visitId: 0,
            userId: this.props.userId,
            patientUserId: this.props.patientUserId,
            isVisitNoteComplete: 0,
            isCompleteSoap: false,
            notesCompleteModal: false,
            sessionNoteComplete: false,
            visitNoteCompletedStatus: 0,
            isLoading: true,
        };
    }

    //componentDidMount
    componentDidMount() {
        this.setState({
            termAssessment: store.get('userSession').applicationData.termAssessment,
            termObjective: store.get('userSession').applicationData.termObjective,
            termSubjective: store.get('userSession').applicationData.termSubjective,
        });
        this.getVisitEncounter(this.props.visitId);
    }

    // getVisitEncounter
    getVisitEncounter(visitId) {
        this.props.getPatientVisitEncounter(visitId, (response) => {
            if (response) {
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    this.setState({
                        isLoading: false,
                        visitNoteCompletedStatus:
                            response.response?.soapNotes?.visitNoteCompletedStatus,
                        assessment: response.response.soapNotes.assessment
                            ? response.response.soapNotes.assessment
                            : '',
                    });
                }
            }
        });
    }

    // onAutoSaveSoapClicked
    onAutoSaveSoapClicked = () => {
        const { visitId, subjective, objective, plan } = this.props;
        this.props.saveSoap(subjective, objective, plan, [], [], visitId, 0, 0, (response) => {
            if (response) {
                if (response.code === 200) {
                    //  this.props.showNotification(response.message, "success");
                    return;
                } else {
                    this.props.showNotification(response.message, 'error');
                }
            }
        });
    };

    // onSaveSoapClicked
    onSaveSoapClicked = (isVisitNoteComplete, isFrom) => {
        const { visitId, subjective, objective, plan } = this.props;
        if (!isFrom) {
            this.setState({ isCompleteSoap: true });
        }
        this.props.saveSoap(
            subjective,
            objective,
            plan,
            [],
            [],
            visitId,
            isVisitNoteComplete,
            0,
            (response) => {
                if (response) {
                    if (!isFrom) {
                        this.setState({ isCompleteSoap: false });
                    } else {
                        this.setState({
                            sessionNoteComplete: true,
                            notesCompleteModal: false,
                        });
                    }
                    if (response.code === 200) {
                        this.props.showNotification(response.message, 'success');
                        return;
                    } else {
                        this.props.showNotification(response.message, 'error');
                    }
                }
            }
        );
    };

    // onClearSoapClicked
    onClearSoapClicked = () => {
        const { subjective, objective, assessment, plan } = this.props;
        const hasContent = subjective || objective || assessment || plan;

        this.props.onUpdateSoap('', '', '', '');

        if (hasContent) {
            this.props.showNotification(this.props.t('notesClearedClickSaveMessage'), 'success');
        }
    };

    render() {
        const { subjective, objective, assessment, plan } = this.props;
        return (
            <>
                {this.state.isLoading ? (
                    <div className="flex items-center justify-center h-screen">
                        <Spinner color="#28235F" />
                    </div>
                ) : (
                    <>
                        {this.props.studentDetails?.tutor?.userId ===
                            JSON.parse(sessionStorage.getItem('userSession'))?.id && (
                            <>
                                <div
                                    id="session_notes"
                                    className="h-full pr-1 overflow-y-auto grow bg-card"
                                >
                                    <div
                                        className="mx-4 my-6 overflow-x-auto rounded-lg"
                                        id="notes"
                                        role="tabpanel"
                                        aria-labelledby="notes-tab"
                                    >
                                        <div className="flex flex-col">
                                            <div className="mb-4">
                                                <label
                                                    htmlFor="select-about"
                                                    className="block mb-2 font-normal text-white"
                                                >
                                                    {this.props.t(
                                                        `${AppConfig.labels.channelnotes}`
                                                    )}
                                                </label>
                                                <textarea
                                                    id="about"
                                                    name="about"
                                                    rows="3"
                                                    maxLength="300"
                                                    onChange={(event) => {
                                                        this.props.onUpdateSoap(
                                                            event.target.value.trimLeft(),
                                                            objective,
                                                            assessment,
                                                            plan
                                                        );
                                                    }}
                                                    disabled={this.state.sessionNoteComplete}
                                                    value={subjective}
                                                    placeholder={`No ${this.props.t(`${AppConfig.labels.channelnotes}`)} found`}
                                                    className="block w-full p-2 text-white rounded resize-none bg-dateselected placeholder:text-secondary sm:text-base"
                                                />
                                            </div>
                                        </div>
                                        <div className="flex flex-col">
                                            <div className="mb-4">
                                                <label
                                                    htmlFor="select-about"
                                                    className="block mb-2 font-normal text-white"
                                                >
                                                    {this.props.t('sessionNotes')}
                                                </label>
                                                <textarea
                                                    id="about"
                                                    name="about"
                                                    rows="3"
                                                    maxLength="300"
                                                    onChange={(event) => {
                                                        this.props.onUpdateSoap(
                                                            subjective,
                                                            event.target.value.trimLeft(),
                                                            assessment,
                                                            plan
                                                        );
                                                    }}
                                                    disabled
                                                    value={objective}
                                                    // placeholder="No session notes found"
                                                    className="block w-full p-2 text-white rounded resize-none bg-dateselected placeholder:text-secondary sm:text-base"
                                                />
                                            </div>
                                        </div>
                                        <div className="flex flex-col">
                                            <div className="mb-0 sm:mb-4">
                                                <label
                                                    htmlFor="select-about"
                                                    className="block mb-2 font-normal text-white"
                                                >
                                                    {this.props.t('recommendations')}
                                                </label>
                                                <textarea
                                                    id="about"
                                                    name="about"
                                                    rows="3"
                                                    maxLength="300"
                                                    onChange={(event) => {
                                                        this.props.onUpdateSoap(
                                                            subjective,
                                                            objective,
                                                            assessment,
                                                            event.target.value.trimLeft()
                                                        );
                                                    }}
                                                    disabled={this.state.sessionNoteComplete}
                                                    value={plan}
                                                    placeholder={this.props.t(
                                                        'noRecommendationsFound'
                                                    )}
                                                    className="block w-full p-2 text-white rounded resize-none bg-dateselected placeholder:text-secondary sm:text-base"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.visitNoteCompletedStatus === 0 && (
                                    <div className="bg-card">
                                        <div className="flex flex-row mx-4 my-6 space-x-4">
                                            <button
                                                className="w-full px-3 py-2 text-base font-medium text-white bg-black rounded-lg"
                                                disabled={
                                                    this.state.isCompleteSoap ||
                                                    !(subjective || objective || assessment || plan)
                                                }
                                                onClick={this.onClearSoapClicked}
                                            >
                                                {this.props.t('clear')}
                                            </button>

                                            <button
                                                className="w-full px-3 py-2 text-base font-medium text-white rounded-lg bg-UIprimary"
                                                onClick={() => this.onSaveSoapClicked(0, false)}
                                                disabled={this.state.isCompleteSoap}
                                            >
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    {this.state.isCompleteSoap ? (
                                                        <Spinner color="#28235F" />
                                                    ) : (
                                                        this.props.t('save')
                                                    )}
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        <NotesCompleteConfirmation
                            openModal={this.state.notesCompleteModal}
                            closeModal={() => {
                                this.setState({
                                    notesCompleteModal: false,
                                    visitNoteCompletedStatus: 0,
                                });
                            }}
                            save={(event) => {
                                this.onSaveSoapClicked(event, true);
                            }}
                        />
                    </>
                )}
            </>
        );
    }
}
/**
 *
 * @param {*} state
 */
const mapStatetoProps = (state) => {
    return {
        videoCallDetails: state.VideoCallState.videoCallDetails,
        subjective: state.VideoCallState.subjective,
        objective: state.VideoCallState.objective,
        assessment: state.VideoCallState.assessment,
        plan: state.VideoCallState.plan,
        visitEncounter: state.VideoCallState.visitEncounter,
    };
};

/**
 *
 * @param {*} dispatch
 */
const mapDispatchtoProps = (dispatch) => {
    return {
        saveSoap: (
            subjective,
            objective,
            plan,
            materialImages,
            handouts,
            visitId,
            isVisitNoteComplete,
            isActiveCall,
            callback
        ) => {
            dispatch(
                saveSoap(
                    subjective,
                    objective,
                    plan,
                    materialImages,
                    handouts,
                    visitId,
                    isVisitNoteComplete,
                    1,
                    callback
                )
            );
        },
        getPatientVisitEncounter: (visitId, callback) => {
            dispatch(getPatientVisitEncounter(visitId, callback));
        },
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
    };
};

const ConnectedActiveVisitSoap = withLanguage(
    connect(mapStatetoProps, mapDispatchtoProps)(ActiveVisitSoap)
);

export default (props) => (
    <LanguageProvider>
        <ConnectedActiveVisitSoap {...props} />
    </LanguageProvider>
);
